"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var createManagedClientsWithState_1 = require("./createManagedClientsWithState");
/**
 * Create managed clients, allowing for declaration of a client map separated from the initialization.  Useful for
 * exporting a shared map of clients and initializing them at runtime.
 *
 * Clients are cached when the state changes.  This function returns an array containing (in the following order):
 *  [0] - The map of clients
 *  [1] - The initialize function (that takes the same arguments as the initializer function passed as a param)
 *
 * @param clientConfig The client configs to manage
 * @param initializer The initializer used to initialize the managed clients, must return a ClientFactory
 */
function createManagedClients(configMap, initializer) {
    var _a = __read(createManagedClientsWithState_1.default(configMap, function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var factory = initializer.apply(void 0, __spread(args));
        return {
            initialState: undefined,
            createClients: function (_) { return factory; },
        };
    }), 2), clientMap = _a[0], initialize = _a[1];
    return [clientMap, initialize];
}
exports.default = createManagedClients;
//# sourceMappingURL=createManagedClients.js.map